module.exports = __webpack_public_path__ + "img/anonymous.a52a6ce7.svg";